import { DebounceInput } from '@components/form/input/debounce-input';
import { ScrollableDiv } from '@components/scrollable-div';
import { useWorkspaceMembers } from '@modules/members/hooks/use-submenu-members';
import { Empty, Menu, Skeleton } from 'antd';
import { ItemType, MenuItemType } from 'antd/es/menu/interface';
import { RiSearchLine } from 'react-icons/ri';
import { MemberCard } from '../sidebar-members/member-card';
import { FilterMembers } from './filter-members';
import { useNavigate, useParams } from 'react-router-dom';
import { useLayoutContext } from '@/container/context/layout/layout-context';
import { SortMemberType } from './sort-member-type';
import { useProfile } from '@components/profile-dropdown/hooks/use-profile-dropdown';
import { useTranslation } from 'react-i18next';
import { capitalize, capitalizeFirst } from '@shared/utils/capitalize';

export default function SubmenuMembersView() {
  const navigate = useNavigate();
  const { memberId = '' } = useParams();
  const { closeSidebarMobileDrawer } = useLayoutContext();
  const { loggedInUserId } = useProfile();
  const { data, loading, loadNextRef, hasNextPage, initialLoading, filter, setFilter, handleSortMember } =
    useWorkspaceMembers();
  const { t } = useTranslation();

  const items: ItemType<MenuItemType>[] =
    data?.data?.map((member) => ({
      type: 'item',
      key: String(member?.id),
      className: 'group py-8 !px-2 group !overflow-visible',
      label: <MemberCard {...member} />,
      onClick: () => {
        closeSidebarMobileDrawer();
        if (loggedInUserId === member?.user?.id) return;
        navigate({
          pathname: '/conversations/member/' + member?.id,
        });
      },
    })) ?? [];

  const loadMoreSkeleton =
    initialLoading || hasNextPage ? (
      <div ref={loadNextRef}>
        <Skeleton active paragraph={false} />
      </div>
    ) : undefined;
  return (
    <>
      <div className="px-2.5 pt-3 space-y-2">
        <DebounceInput
          allowClear
          size="large"
          prefix={<RiSearchLine />}
          placeholder={capitalizeFirst(t('find_member')) + '..'}
          defaultValue={filter.query}
          setDebouncedValue={(v) => setFilter((prev) => ({ ...prev, query: v }))}
        />
        <section className="flex items-center justify-between">
          <FilterMembers setFilter={setFilter} />
          <SortMemberType onChange={handleSortMember} />
        </section>
      </div>
      <ScrollableDiv className="custom-sidebar-menu pt-2">
        {items.length || loading ? (
          <Menu
            selectedKeys={[String(memberId)]}
            style={{ height: 20, background: 'transparent' }}
            mode="inline"
            className="h-full border-0! custom-menu"
            items={[
              ...items,
              {
                key: 'lazy-loader',
                style: { display: initialLoading || hasNextPage ? 'block' : 'none' },
                label: loadMoreSkeleton,
              },
            ]}
          />
        ) : (
          <Empty description={capitalize(t('no_members_found')) + '...'} className="mt-4" />
        )}
      </ScrollableDiv>
    </>
  );
}
